import type { IState } from 'shared/store';

export const selectEtazhiBlackFridayPricesData = (state: IState) => {
  return state.etazhiBlackFriday?.pricesData ?? null;
};
